'use strict'

export let norwegian={
  general: {
    login: "Logg inn",
    profile: "Profil",
    searchCriteria: "Angi søkekriterie",
    search: "Søk",
    addProject: "Legg til prosjekt",
    filterProjects: "Filtrer prosjekt",
    projectMenu: "Prosjektmeny",
    otherPortfolio: "Annet",
    unknownTenantName: "Ditt navn",
    sections: {
      programmes: "Program",
      projects: "Prosjekter",
      projectsAndReleases: "Prosjekter og oppdateringer",
      releases: "Oppdateringer",
      products: "Produkter og plattformer"
    }
  },
  requestedStageTransition: "Forespurt",
  requestedPhase: "Forespurt fase",
  projectStatus: {
    stopped: "stoppet",
    paused: "pauset"
  },
  columns: {
    portfolio: "Portefølje",
    numberOfProjects: "# Aktiviteter",
    priority: "Prioritet",
    name: "Navn",
    status: "Status",
    stage: "Del",
    benefits: "Gevinst",
    time: "Tid",
    cost: "Kostnad",
    quality: "Kvalitet",
    scope: "Omfang",
    risk: "Risiko"
  },
  inactive: {
    hide: "Skjul inaktive prosjekter",
    show: "Vis {0} inaktive prosjekt{1}",
    projectsPlural: "er"
  },
  prioritize: {
    drop: "Slipp dine prioriterte prosjekter eller oppdateringer her"
  },
  empty: "Ingen prosjekter i porteføljen, vennligst legg til ett prosjekt.",
  programme: {
    columns: {
      name: "Programnavn",
      stage: "Seksjon"
    },
    prioritize: {
      drop: "Slipp dine prioriterte program her"
    },
    inactive: {
      hide: "Skjul inaktive progam",
      show: "Vis {0} inaktive program"
    }
  },
  product: {
    noActiveReleases: "Ingen aktiv oppdatering",
    columns: {
      name: "Produktnavn",
      stage: "Oppdatering"
    },
    prioritize: {
      drop: "Slipp dine prioriterte produkter her"
    },
    inactive: {
      hide: "Skjul inaktive produkter",
      show: "Vis {0} inaktive produkt"
    }
  }
};



// WEBPACK FOOTER //
// ./views/portfolio/labels/norwegian.js